import { render, staticRenderFns } from "./OverviewTotalTwo.vue?vue&type=template&id=42dbdfe0&scoped=true&"
import script from "./OverviewTotalTwo.vue?vue&type=script&lang=js&"
export * from "./OverviewTotalTwo.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTotalTwo.vue?vue&type=style&index=0&id=42dbdfe0&scoped=true&lang=scss&"
import style1 from "./OverviewTotalTwo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbdfe0",
  null
  
)

export default component.exports